export const Userdata = [
    {
      name: 'Jan',
    "Active Users": 4000,
    },
    {
      name: 'Feb',
      "Active Users": 3000,
    },
    {
      name: 'Mar',
      "Active Users": 2000,
    },
    {
      name: 'Apr',
      "Active Users": 2780,
    },
    {
      name: 'May',
      "Active Users": 1890,
    },
    {
      name: 'Jun',
      "Active Users": 2390,
    },
    {
      name: 'Jul',
      "Active Users": 3490,
    },
    {
        name: 'Aug',
        "Active Users": 3990,
      },
      {
        name: 'Sep',
        "Active Users": 3400,
      },
      {
        name: 'Oct',
        "Active Users": 3890,
      },
      {
        name: 'Nov',
        "Active Users": 1790,
      },
      {
        name: 'Dec',
        "Active Users": 4790,
      },
  ];